import React from "react";
import SVGFactory, { SVGName } from "../../../svgFactory";
import "./PoweredByBik.css";

const PoweredByBik: React.FC<{ textOnLeft?: string; textOnLeftStyle?: {}, onTandCClickHandle?: (flag: boolean) => void }> = ({
  textOnLeft,
  textOnLeftStyle,
  onTandCClickHandle
}) => {
  const redirectToBik = () => {
    window.open(
      "https://bik.ai/?utm_campaign=SS_STW_APR&utm_medium=Gamification&utm_source=BIK_Logo"
    );
  };
  return (
    <div className="bik-sm-powereby"

    >
      {!textOnLeft && (
        <p onClick={() => {
          if (onTandCClickHandle) {
            onTandCClickHandle(true)
          }
        }}>
          T&C apply<sup>*</sup>
        </p>
      )}
      {textOnLeft ? textOnLeft : <></>}
      <div onClick={redirectToBik}>
        <SVGFactory name={SVGName.POWERED_BY_BIK} />
      </div>
    </div>
  );
};
export default PoweredByBik;
